export class TemplateChoiceInspection {
    id = 0;
    description = '';
    templateChoiceTypeId = 0;
    TemplateChoiceType = undefined;
}
